import React from "react";
import { CardLayout } from "components/cardLayout";
import { companylogo } from "assets/images"
import "./OrignCompanyDetailCard.scss"
import { getEstimatorDetails } from 'core/services/getEstimatorDetailsService'

export interface CompanyDetailCardProps {

}

export interface CompanyDetailCardState {
    companyDetails: any;
}

class OrignCompanyDetailCard extends React.Component<CompanyDetailCardProps, CompanyDetailCardState> {
    private _isMounted: boolean = false;
    constructor(props: CompanyDetailCardProps) {
        super(props);
        this.state = {
            companyDetails: []
        };
    }

    async fetchData() {
        var CID = localStorage.getItem("CID") || "0";
        let response = await getEstimatorDetails(CID)
        this.setState({ companyDetails: response[0] })
        console.log("CompDetail:" , response[0]);
    }

    componentDidMount() {
        this._isMounted = true;
        this.fetchData();
    }
    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        const add="<b>All My Sons Moving & Storage of Dallas, LLC</b>"
        return (
            <CardLayout style={{alignItems:"start"}}>

                <div className="origin-detail">
                    <b>Booking Agent/Broker</b>
                </div>
                {/* <div className="address">
                   {this.state.companyDetails.origin}
                </div> */}
                <div className="address fontSizeNormal">
                    <h3><div id="terms-content" dangerouslySetInnerHTML={{__html: this.state.companyDetails.bookingAgentAddress}}/></h3>
                </div>
                <div className="origin-detail">
                    <h1>US DOT #:</h1>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{this.state.companyDetails.agentMC}</h3>
                </div>
                <div className="origin-detail">
                    <h1>MC #:</h1>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{this.state.companyDetails.agentDOT}</h3>
                </div>
                <br/>
                
                <div className="origin-detail divider">
                    <b><br/>Carrier</b>
                </div>
                <div className="address">{this.state.companyDetails.destination}
                </div>
                <div className="address fontSizeNormal">
                    {/* <b>Address:</b> */}
                    {/* <h3>2400 Old Mill Rd. Carrollton, TX 75007</h3> */}
                    <h3> <div id="terms-content" dangerouslySetInnerHTML={{__html:this.state.companyDetails.estimatorAdd1+" "+ this.state.companyDetails.estimatorAdd2}}/></h3>
                </div>
                <div className="origin-detail">
                    <h1>US DOT #:</h1>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{this.state.companyDetails.dOT}</h3>
                </div>
                <div className="origin-detail">
                    <h1>MC #:</h1>
                    {/* <h3>All My Sons Moving & Storage of Dallas, LLC</h3> */}
                    <h3>{this.state.companyDetails.mC}</h3>
                </div>
            </CardLayout>
        );
    }
}

export default OrignCompanyDetailCard;